import React from "react";
import { Button, Col, FormGroup, Input, Label, Row, Spinner, Alert } from "reactstrap";
import Select from "react-select";

interface IInputSelectProp {
    value: string,
    label: string,
    name: string,
    labelAttr: string,
    valueAttr: string,
    optionList: Array<any>,
    showRequired?: boolean,
    placeholder?: string,
    id?: string,
    onSelect: (e:any, name:string)=>void,
    error?: any
}

interface IInputSelectState {
  isTouched: boolean
}

class InputSelect extends React.Component<IInputSelectProp, IInputSelectState> {

  state = {
    isTouched: false
}

componentDidMount = () => {
  this.setState({isTouched: false})
}


getSelectOptions = (list:Array<any>, labelAttr:string, valueAttr:string) => {
    return list.map((item) => {
          return { value: item[valueAttr], label: item[labelAttr] }
    });
}
    
getSelectedIndex = (list:Array<any>, valueAttr:string, value:string) => {
    return list.findIndex((item) => item[valueAttr] === value)
}

onSelectChange = (option:any, attrName:string) => {
    let value = option.value;
    this.props.onSelect(value, attrName);
    this.setState({isTouched: true});
  }

  render() {

    const options = this.getSelectOptions(this.props.optionList, this.props.labelAttr, this.props.valueAttr);
    const selIndex = this.getSelectedIndex(this.props.optionList, this.props.valueAttr, this.props.value);
    const { isTouched } = this.state;
    return (
          <FormGroup>
              <Label htmlFor="data-category">{this.props.label} {this.props.showRequired && <span className="primary">*</span>}</Label>
            <Select
              classNamePrefix="select"
              onChange={(option:any) => this.onSelectChange(option, this.props.name)}
              value={options[selIndex]}
              name={this.props.name}
              placeholder={this.props.placeholder}
              className={` ${this.props.error && isTouched && "is-invalid"}`}
              options={options}
              isClearable={true}
            />
            {this.props.error && isTouched && <div className="invalid-tooltip mt-25">{this.props.error}</div>}
          </FormGroup>
    );
  }
}
export default InputSelect;
